// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f256809b","977":"ec71b922"}[chunkId] + ".chunk.js";
};